export const useInitializeClassroomStores = async (
  classroomId: string,
  studentId: string
) => {
  try {
    const studentClassroomStore = useStudentClassroomDataStore(studentId);
    await studentClassroomStore.initializeStudentClassroomData();

  } catch (e) {
    console.error(e);
  }

  // try {
  //   const userClassroomStore = useUserClassroomDataStore(classroomId);
  //   await userClassroomStore.initialize();

  // } catch (e) {
  //   console.error(e);

  // }
};
